import { getAllPlans } from '@/lib/data/getHomePlans';
import { IHousePlanHit } from '@/lib/search/types';
import { renderCard } from './utils/renderCards';

export const OrFilteredGridServer = async () => {
  const plans: IHousePlanHit[] = await getAllPlans();
  const filteredPlans = plans.filter(
    (plan) => plan?.FloorPlans?.[0].IsPreferred,
  );

  return (
    <div
      id="or-filter-grid-ssr"
      aria-hidden="true"
      className="container sr-only grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3"
    >
      {filteredPlans.map((card) => {
        return <div key={card.objectID}>{renderCard(card)}</div>;
      })}
    </div>
  );
};
